import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
} from '@chakra-ui/react'

export function VirtualDeviceModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Virtual Device</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>This is the virtual device modal. Customize as needed.</Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
